/** biome-ignore-all lint/performance/noAccumulatingSpread: <explanation> */
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import structureTypes from '../../../../common/constants/structureTypes'
import ServerPage from 'src/shared/types/server-page-interface'
import migrateBlogPostContentPlaceholder from './migrateBlogPostContentPlaceholder'

export default function (page: ServerPage): [ServerPage, boolean] {
  let isChanged = false
  try {
    const entities = Object.values(page.content.entities).reduce(
      (prev, entity) => {
        if (entity.type === structureTypes.BLOG_POST_CONTENT_PLACEHOLDER) {
          isChanged = true
        }

        return {
          ...prev,
          [entity.id]:
            entity.type === structureTypes.BLOG_POST_CONTENT_PLACEHOLDER
              ? migrateBlogPostContentPlaceholder(entity as OldEntityInterface)
              : entity,
        }
      },
      {},
    )
    return [
      {
        ...page,
        content: {
          ...page.content,
          entities,
        },
      },
      isChanged,
    ]
    // biome-ignore lint/correctness/noUnusedVariables: <explanation>
  } catch (e) {
    console.log(`--error--`, page, page.id)

    return [page, false]
  }
}
